import * as React from 'react';
import {ButtonProps} from '@volkswagen-onehub/whitelabel-e-mobility-commons';
import {CTA} from '@volkswagen-onehub/components-core';
import {BrandThemeProvider} from '../theme';

/* todo: needs to be exported by components core */
type Emphasis = 'primary' | 'secondary' | 'tertiary' | 'none';

export function Button(props: ButtonProps): JSX.Element {
  const emphasis: Emphasis =
    props.emphasis === 'text'
      ? 'tertiary'
      : props.emphasis === 'secondary'
        ? 'secondary'
        : 'primary';

  const {
    ariaLabel,
    buttonSize,
    children,
    onClick,
    tabIndex,
    title,
    type,
    tag = 'button',
    href,
    icon,
    testId,
    target,
    ref,
    iconPosition,
  } = props;

  const commonProps = {
    'aria-label': ariaLabel,
    'size': buttonSize,
    tabIndex,
    title,
    emphasis,
    icon,
    'data-testid': testId,
    target,
    iconPosition,
  };

  if (tag === 'button') {
    return (
      <CTA
        {...commonProps}
        tag="button"
        type={type}
        onClick={onClick as React.MouseEventHandler<HTMLButtonElement>}
        ref={ref}
      >
        {children}
      </CTA>
    );
  } else {
    return (
      <CTA
        {...commonProps}
        tag="a"
        href={href}
        onClick={onClick as React.MouseEventHandler<HTMLAnchorElement>}
        ref={ref}
      >
        {children}
      </CTA>
    );
  }
}

export function ButtonInverted(props: ButtonProps): JSX.Element {
  return (
    <BrandThemeProvider theme="inverted">{Button(props)}</BrandThemeProvider>
  );
}
